module.exports = "mutation proposalInvoiceSent($adviceRequestId:String!){proposalInvoiceSent(adviceRequestId:$adviceRequestId)}"